<template>
	<b-row>
		<b-col>
			<h4 class="mt-3">Weapons</h4>
			<b-list-group>

				<b-list-group-item class="p-0 mb-3">
					<b-row class="mx-0">
						<b-col cols="1" class="col-light border-bottom border-right">
							<strong>Lvl</strong>
						</b-col>
						<b-col cols="4" class="col-light border-bottom border-right">
							<strong>Name</strong>
						</b-col>
						<b-col cols="1" class="col-light border-bottom border-right">
							<strong>Atk</strong>
						</b-col>
						<b-col cols="2" class="col-light border-bottom border-right">
							<strong>Damage</strong>
						</b-col>
						<b-col cols="4" class="col-light border-bottom">
							<strong>Critical</strong>
						</b-col>
					</b-row>
					<b-row class="mx-0">
						<b-col cols="2" class="col-light border-right">
							<strong>Range</strong>
						</b-col>
						<b-col cols="3" class="col-light border-right">
							<strong>Ammo, Usage</strong>
						</b-col>
						<b-col cols="7" class="col-light">
							<strong>Special</strong>
						</b-col>
					</b-row>
				</b-list-group-item>

				<b-list-group-item class="p-0 mb-3" v-for="(weapon, weaponID) in Character.Equipment.Weapons" :key="'weapon-'+weaponID">
					<b-row class="mx-0">
						<b-col cols="1" class="col-light border-bottom border-right">
							{{weapon.Level}}
						</b-col>
						<b-col cols="4" class="col-light border-bottom border-right">
							<strong>{{weapon.Name}}</strong>
						</b-col>
						<b-col cols="1" class="col-light border-bottom border-right">
							{{totalAttack(weapon.AttackType,weapon.AttackMisc)|bonus}}
						</b-col>
						<b-col cols="2" class="col-light border-bottom border-right">
							{{weapon.Damage}}
						</b-col>
						<b-col cols="4" class="col-light border-bottom">
							{{weapon.Critical}}
						</b-col>
					</b-row>
					<b-row class="mx-0">
						<b-col cols="2" class="col-light border-right">
							{{weapon.Range}}
						</b-col>
						<b-col cols="3" class="col-light border-right">
							<span v-if="weapon.AmmoType !== ''">{{weapon.AmmoType}} {{weapon.Capacity}}, Use {{weapon.Usage}}</span>
						</b-col>
						<b-col cols="7" class="col-light">
							{{weapon.Special}}
						</b-col>
					</b-row>
				</b-list-group-item>

			</b-list-group>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters('character/equipment',[
			'totalAttack'
		]),
	}
}
</script>

<style scoped>

</style>